import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";

export default class IdentityType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'country/identity-type';

    /**
     *
     * @type {string}
     */
    static entity = 'countryIdentityTypes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
            identity_type_cid: this.number(null).nullable(),
            country: this.hasOne(Country, 'country_id'),
        }
    }
}
